import React from 'react';
import MUIDataTable from "mui-datatables";
import { CircularProgress } from "@mui/material";
import { handlePagination, postApi } from "../../../utils/apiFunction";
import { ThemeProvider } from '@mui/material/styles';
import { tableTheme } from '../../../themes/tableTheme';
import { adalApiFetch } from '../../../../adalConfig';
import DataTableStandard from "../../../components/DataTableStandard";
import DayToggle from "../../../components/DayToggle";
import { numberFormat } from '../../../utils/numberFunctions';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from "@mui/material/IconButton";
import { useJumboTheme } from "@jumbo/hooks";
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";


const AccountMaps = (props) => {
    const uri = process.env.REACT_APP_BASE_URL;
    const [loading, setLoading] = React.useState(false);
    const [columns, setColumns] = React.useState([]);
    const [procurement, setProcurement] = React.useState([]);
    const { theme } = useJumboTheme();
    const Swal = useSwalWrapper();
    const [tableReload, setTableReload] = React.useState(false);

    const deleteMapping = React.useCallback(async (dataIndex) => {
        const rowObj = procurement[dataIndex];
        const name = rowObj?.name ?? dataIndex;
        Swal.fire({
            html: 'Are you sure you want to delete this role?',
            icon: 'warning',
            title: 'Confirm Delete...',
            showCancelButton: true,
            confirmButtonText: 'Yes, Continue',
            cancelButtonText: 'No',

        }).then(async result => {
            if (result.value) {
                setLoading(true);
                const id = rowObj?.id;
                await postApi('/RoleAccounts/Delete/' + id);
                props.reloadFunc();
                setLoading(false);
            } else if (result.dismiss === Swal.DismissReason.cancel) {

            }
        });
    }, [procurement, tableReload]);

    React.useEffect(() => {
        var cols = [{
            name: 'role',
            label: 'Role',
        },
        {
            name: 'account',
            label: 'Account',
        },
        {
            name: 'subaccount',
            label: 'Sub Account',
        },
        {
            name: 'delete',
            label: 'Delete',
            options: {
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <IconButton
                            aria-label="delete"
                            onClick={(e) => { e.stopPropagation(); deleteMapping(dataIndex); }}
                            title="Delete"
                        >
                            <DeleteIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                    );
                },
            }
        }]
        setColumns(cols);
    }, [procurement])


    const options = {
        filterType: 'dropdown',
        selectableRowsHideCheckboxes: true,
        fixedHeader: true,
        tableBodyMaxHeight: '600px',
        responsive: 'standard',
        onRowClick: props.onClick ? props.onClick(procurement) : (() => { })

    };
    React.useEffect(() => {
        setProcurement([]);
        getProcurementData();
    }, [props.reload]);

    var getProcurementData = async (location, start, end) => {
        setLoading(true);
        const response = await adalApiFetch(fetch, uri + '/RoleAccounts/Get');
        const data = await response.json();
        console.log(data)
        setLoading(false);
        setProcurement(data.map((t) => {
            return {
                id: t.id,
                roleId: t.role.id,
                role: t.role.name,
                accountId: t.account?.id,
                account: t.account?.description,
                subaccountId: t.subAccount?.id,
                subaccount: t.subAccount?.description
            };
        }));
        console.log("Mapped Procurement Data");
        console.log(procurement);
    }
    return (
        <DataTableStandard
            data={props.filter ? props.filter(procurement) : procurement}
            title={"Approval Mapping"}
            columns={columns}
            options={options}
            returnSearch={!loading}
            reload={props.reloadFunc}
        />
    );
};

export default AccountMaps;
